// extracted by mini-css-extract-plugin
module.exports = {"content":"write-partner--content--WtBn8"};